import { ExportTypeEnum } from "@king-ict/eupisi-ui/models/Export/ExportTypeEnum";
import { api } from "@king-ict/eupisi-ui/utils";

import { SchoolYear } from "../../models/SchoolYear";

const apiUrlPrefix: string = "school-years";

export const getSchoolYearList = async () => {
  return api.get(apiUrlPrefix) as Promise<SchoolYear[]>;
};

export const getSchoolYear = async (id: number) => {
  return api.get(`${apiUrlPrefix}/${id}`) as Promise<SchoolYear>;
};

export const getSchoolYearCurrent = async () => {
  return api.get(`${apiUrlPrefix}/current`) as Promise<SchoolYear>;
};

export const getSchoolYearExport = async (id: number, type: ExportTypeEnum) => {
  return api.download(`${apiUrlPrefix}/export/${id}/${type}`) as Promise<any>;
};
